/**
 * A wrapper to manage localStorage
 */
export default class LocalStorage {
    /**
     * retrieve a key from storage
     * @param key
     * @returns {string}
     */
    static get (key) {
      return window.localStorage.getItem(key)
    }

    /**
     * Sets a key in storage
     * @param key
     * @param value
     * @returns {string}
     */
    static set (key, value) {
      return window.localStorage.setItem(key,value)
    }

    /**
     * removes a key from storage
     * @param key
     * @returns {void}
     */
    static remove (key) {
      return window.localStorage.removeItem(key)
    }

    /**
     * Clears storage
     * @returns {void}
     */
    static clear () {
      return window.localStorage.clear()
    }
}